import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { realtimeDB } from "./Backend";
import horemowlogo from "./images/horemow.png";
import sidebarimg from "./images/best4.jpg";


const About = () => {
    const [abouttext,setAbout]=useState("");

    useEffect(()=>{
        onValue(ref(realtimeDB,"aboutpage"),(snapshot) =>{
          if(snapshot.exists()){
            setAbout(snapshot.val());
          };
        });
      },[]);

    return (
        <div className="about">
            <img src={horemowlogo} alt="Horemow Ghana" />
            {
                abouttext && 
                <div className="aboutdiv" style={{
                    backgroundImage:`url(${sidebarimg})`,
                    backgroundPosition:"center",
                    backgroundSize:"100%"
                    }}>
                    <pre>{abouttext}</pre>
                </div>
            }
        </div> 
    );
}
export default About;